module.exports = __webpack_public_path__ + "img/width-medium.b30f06f.webp";